export default __webpack_public_path__ + "assets/images/69075d37a35206929aea14ccbcc4cdeb.png";